/* YR • Recommend Tabs — desktop tabs + mobile dropdown + horiz scroller */
(function () {
  const sections = document.querySelectorAll('[data-yr-rec]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const tabs = root.querySelectorAll('.yr-rec__tab');
    const panels = root.querySelectorAll('.yr-rec__panel');

    // Desktop chips
    tabs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.tab;
        tabs.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => p.classList.toggle('is-active', p.id.endsWith(id)));
      });
    });

    // Mobile dropdown
    const dd = root.querySelector('[data-dropdown]');
    if (dd) {
      const trigger = dd.querySelector('[data-dropdown-trigger]');
      const menu = dd.querySelector('[data-dropdown-menu]');
      const label = trigger.querySelector('.yr-select__label');
      const options = dd.querySelectorAll('.yr-rec__option');

      const close = () => {
        dd.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        dd.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.focus({ preventScroll: true });
      };

      trigger.addEventListener('click', () => {
        dd.classList.contains('is-open') ? close() : open();
      });

      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          const id = opt.dataset.tab;
          // update panels
          panels.forEach((p) => p.classList.toggle('is-active', p.id.endsWith(id)));

          // sync desktop tabs (for responsive switches)
          const desktopTabs = root.querySelectorAll('.yr-rec__tab');
          desktopTabs.forEach((b) => {
            const active = b.dataset.tab === id;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          // update label + selected
          label.textContent = opt.textContent.trim();
          options.forEach((o) => o.setAttribute('aria-selected', o === opt ? 'true' : 'false'));
          close();
        });
      });

      // close on outside / Escape
      document.addEventListener('click', (e) => { if (!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }

    // AJAX add-to-cart (fallback -> normal form POST)
    root.addEventListener('submit', async (e) => {
      const form = e.target.closest('.yr-card__form');
      if (!form) return;
      e.preventDefault();

      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      try {
        const fd = new FormData(form);
        await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (btn) btn.textContent = root.dataset.addedLabel || 'Добавлено!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          if (btn) { btn.textContent = root.dataset.addLabel || 'В Корзину'; btn.disabled = false; }
        }, 1400);
      } catch (err) {
        form.submit(); // graceful fallback
      }
    });
  });
})();
